<template>
  <el-card class="card linkFormSection filterResourceCard">
    <div slot="header">
      <strong class="filterResourceCard__title">过滤条件</strong>
    </div>
    <div>
      <el-form-item label="国家（选填）">
        <el-radio-group
          v-model="country.isExclude"
          size="small"
          class="filterResourceCard__countryMode"
          :disabled="disabled"
        >
          <el-radio-button :label="false">包含所选国家</el-radio-button>
          <el-radio-button :label="true">排除所选国家</el-radio-button>
        </el-radio-group>
        <div class="filterResourceCard__countrySelect">
          <el-select
            v-model="country.countries"
            multiple
            filterable
            collapse-tags
            popper-class="genericResourceDropdown"
            placeholder="请选择国家"
            :disabled="disabled"
          >
            <el-option
              v-for="item in countryOption"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
      </el-form-item>

      <div class="filterResourceCard__osVersionPair">
        <el-form-item
          label="Android 系统版本（选填）"
          class="filterResourceCard__osVersionCol"
        >
          <div class="filterResourceCard__versionRow">
            <el-input
              placeholder="开始"
              class="filterResourceCard__versionInput"
              type="number"
              v-model.number="androidVersion.start"
              :disabled="disabled"
            />
            <span class="filterResourceCard__versionDash">-</span>
            <el-input
              placeholder="结束"
              type="number"
              class="filterResourceCard__versionInput"
              v-model.number="androidVersion.end"
              :disabled="disabled"
            />
            <el-input
              placeholder="跳过版本，逗号分隔"
              class="filterResourceCard__skipInput filterResourceCard__skipInput--os"
              v-model="androidVersion.skip"
              :disabled="disabled"
            />
          </div>
        </el-form-item>

        <el-form-item
          label="iOS 系统版本（选填）"
          class="filterResourceCard__osVersionCol"
        >
          <div class="filterResourceCard__versionRow">
            <el-input
              placeholder="开始"
              class="filterResourceCard__versionInput"
              type="number"
              v-model.number="iosVersion.start"
              :disabled="disabled"
            />
            <span class="filterResourceCard__versionDash">-</span>
            <el-input
              placeholder="结束"
              type="number"
              class="filterResourceCard__versionInput"
              v-model.number="iosVersion.end"
              :disabled="disabled"
            />
            <el-input
              placeholder="跳过版本，逗号分隔"
              class="filterResourceCard__skipInput filterResourceCard__skipInput--os"
              v-model="iosVersion.skip"
              :disabled="disabled"
            />
          </div>
        </el-form-item>
      </div>

      <el-form-item label="应用版本（选填）">
        <div
          v-for="(item, index) in appVersion"
          :key="item._rowId || index"
          class="filterResourceCard__appVersionRow"
        >
          <el-input
            placeholder="开始"
            type="number"
            class="filterResourceCard__versionInput"
            v-model.number="item.start"
            :disabled="disabled"
          />
          <span class="filterResourceCard__versionDash">-</span>
          <el-input
            placeholder="结束"
            type="number"
            class="filterResourceCard__versionInput"
            v-model.number="item.end"
            :disabled="disabled"
          />
          <el-input
            placeholder="跳过版本，逗号分隔"
            class="filterResourceCard__skipInput"
            v-model="item.skip"
            :disabled="disabled"
          />
          <el-select
            v-model="item.dataSetId"
            class="filterResourceCard__dataSetSelect"
            popper-class="genericResourceDropdown"
            placeholder="请选择数据集"
            filterable
            clearable
            :disabled="disabled"
          >
            <el-option
              v-for="opt in dataOptions"
              :key="opt.id"
              :label="opt.name"
              :value="opt.id"
            />
          </el-select>
          <button
            v-show="appVersion.length > 1 && !disabled"
            type="button"
            class="filterResourceCard__iconBtn filterResourceCard__iconBtn--remove"
            aria-label="删除此行"
            @click="deleteAppVersion(index)"
          >
            <i class="el-icon-remove-outline" />
          </button>
          <button
            v-show="appVersion.length - 1 === index && !disabled"
            type="button"
            class="filterResourceCard__iconBtn filterResourceCard__iconBtn--add"
            aria-label="添加一行"
            @click="addAppVersion"
          >
            <i class="el-icon-circle-plus-outline" />
          </button>
        </div>
      </el-form-item>
    </div>
  </el-card>
</template>

<script>
import { getCountry } from '../api/comment'

export default {
  name: 'filterClassifyCard',
  props: {
    country: Object,
    iosVersion: Object,
    androidVersion: Object,
    appVersion: Array,
    dataOptions: Array,
    disabled: Boolean,
  },
  data() {
    return {
      countryOption: [],
    }
  },
  watch: {
    // 父级异步回填 appVersion 时 created 已过；immediate 覆盖首屏空数组 → 后续有数据补 _rowId
    appVersion: {
      immediate: true,
      handler() {
        this.ensureAppVersionRowIds()
      },
    },
  },
  created() {
    this.getCountryList()
  },
  methods: {
    ensureAppVersionRowIds() {
      if (!Array.isArray(this.appVersion)) {
        return
      }
      let changed = false
      const next = this.appVersion.map((item) => {
        if (item && !item._rowId) {
          changed = true
          return { ...item, _rowId: this.createAppVersionRowId() }
        }
        return item
      })
      // 不直接改 prop：缺 _rowId 时通过事件交给父级换新数组
      if (changed) {
        this.$emit('update:appVersion', next)
        this.$emit('app-version-change', next)
      }
    },
    createAppVersionRowId() {
      return `classify-app-ver-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
    },
    getCountryList() {
      getCountry().then((res) => {
        if (res.success) {
          this.countryOption = res.data
        }
      })
    },
    deleteAppVersion(index) {
      const next = (this.appVersion || []).slice()
      next.splice(index, 1)
      this.$emit('update:appVersion', next)
      this.$emit('app-version-change', next)
    },
    addAppVersion() {
      const next = (this.appVersion || []).slice()
      next.push({
        _rowId: this.createAppVersionRowId(),
        start: '',
        end: '',
        skip: '',
        dataSetId: '',
      })
      this.$emit('update:appVersion', next)
      this.$emit('app-version-change', next)
    },
  },
}
</script>

<style scoped>
.filterResourceCard__title {
  font-size: 14px;
}

.filterResourceCard__countryMode {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.filterResourceCard__countrySelect {
  max-width: 480px;
}

.filterResourceCard__osVersionPair {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 16px 24px;
  margin-bottom: 18px;
}

.filterResourceCard__osVersionCol {
  flex: 1 1 280px;
  min-width: 0;
  margin-bottom: 0;
}

.filterResourceCard__versionRow,
.filterResourceCard__appVersionRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.filterResourceCard__appVersionRow {
  margin-bottom: 10px;
}

.filterResourceCard__appVersionRow:last-child {
  margin-bottom: 0;
}

.filterResourceCard__versionInput {
  width: 88px;
  flex-shrink: 0;
}

.filterResourceCard__skipInput {
  width: 200px;
  flex-shrink: 0;
}

.filterResourceCard__skipInput--os {
  flex: 1 1 120px;
  width: auto;
  min-width: 120px;
}

.filterResourceCard__dataSetSelect {
  width: 220px;
  flex-shrink: 0;
}

.filterResourceCard__versionDash {
  color: var(--link-ink-muted, #a8a29e);
  user-select: none;
}

.filterResourceCard__iconBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid var(--link-line-strong, #e5dfd6);
  border-radius: 8px;
  background: var(--link-field-bg, #f3f0ea);
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;
}

.filterResourceCard__iconBtn--add {
  color: var(--link-accent, #2563eb);
}

.filterResourceCard__iconBtn--add:hover {
  background: var(--link-accent-bg, #f0f7ff);
  border-color: var(--link-accent-border, #cce5ff);
}

.filterResourceCard__iconBtn--remove {
  color: var(--link-status-danger-ink, #dc2626);
}

.filterResourceCard__iconBtn--remove:hover {
  background: var(--link-status-error-bg, #fef2f2);
  border-color: var(--link-status-error-border, #fecaca);
}

.filterResourceCard__iconBtn i {
  font-size: 16px;
}
</style>
